import { utils } from 'xlsx';

import type { ConvertExcelDataWithSchemaFn } from 'src/types/bulkUpload';
import { readExcelFile } from 'src/utils/excel';

export const parseExcelEntitiesData = async <TExcelRow, TResultRow>(
  excelFile: File,
  convertDataWithSchema: ConvertExcelDataWithSchemaFn<TExcelRow, TResultRow>,
): Promise<TResultRow[]> => {
  const excelWorkbook = await readExcelFile(excelFile);
  if (!excelWorkbook) return [];

  const sheets = excelWorkbook.Sheets;
  const sheetsName = excelWorkbook.SheetNames[0];
  if (!sheetsName) return [];

  const sheet = sheets[sheetsName];
  if (!sheet) return [];

  const excelWorkbookData = utils.sheet_to_json<TExcelRow>(sheet, {
    blankrows: false,
    rawNumbers: false,
  });

  const employers = convertDataWithSchema(excelWorkbookData);

  return employers;
};
